export function trimLeadingSlashes(str: string): string {
	return str?.replace(/^\/+/, '');
}

export function isEmptyOrUndefined(value: string): boolean {
	return isNullOrUndefined(value) || value.length <= 0;
}

export function isNullOrUndefined(value: any): boolean {
	return value === null || value === undefined;
}

export function trimFirstToken(source: string, token: string): string {
	return source.replace('/', '');
}

export function parseIntIfPresent(value: string | null | undefined, radix?: number): number | undefined {
	if (typeof value === 'string') {
		return parseInt(value, radix);
	} else {
		return undefined;
	}
}
